import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_TYPE}`;

export const getProducts = async (id: number, type: string) => {
  const res = await api.get(
    // `${apiEndPoint}/${id}/tags?isAssigned=false&type=${type}`,
    `${apiEndPoint}/assets/${id}/names?search=${type}`,
  );

  return res.data;
};
